<h2>Button</h2>
<div class="admin-container">
  <form class="form">
    <div class="input-group">
      <label>Icon</label>
      <div class="images">
        <img
          src="/admin-icons/tickets.svg"
          [class.selected]="sectionData.icon === '/admin-icons/tickets.svg'"
          (click)="sectionData.icon = '/admin-icons/tickets.svg'"
        />
        <img
          src="/admin-icons/stars.svg"
          [class.selected]="sectionData.icon === '/admin-icons/stars.svg'"
          (click)="sectionData.icon = '/admin-icons/stars.svg'"
        />
      </div>
    </div>
    <div class="input-group">
      <label>Text</label>
      <input pInputText [(ngModel)]="sectionData.text" name="textInput" type="text" />
    </div>
    <div class="input-group">
      <label>Link</label>
      <input pInputText [(ngModel)]="sectionData.link" name="linkInput" type="text" />
    </div>
  </form>
</div>
